import { useState } from "react";

import ApiRequestErrorHandler from "../../../../global/ApiRequestErrorHandler";
import STRINGS from "../utils/strings";

export const getFailureErrorDetails = (error) => error?.response?.data ?? error;

export default function useModalHandler() {
  const [mode, setMode] = useState(null);
  const [modalSize, setModalSize] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [showFailureModal, setShowFailureModal] = useState(false);
  const [additionalDetails, setAdditionalDetails] = useState({});

  const openFailureModal = (error) => {
    setAdditionalDetails((prev) => ({
      ...prev,
      error: ApiRequestErrorHandler(getFailureErrorDetails(error)),
      handleFailure: () => handleFailure(),
    }));
    setShowFailureModal(true);
  };

  const openSuccessModal = () => {
    setShowFailureModal(false);
    setAdditionalDetails({
      handleSuccess: handleSuccess,
    });
    setMode(STRINGS.MODAL_MODE.SUCCESS);
    setModalSize(STRINGS.MODAL_SIZE.X_SMALL);
    handleOpenModal();
  };

  const openWarningModal = () => {
    setShowFailureModal(false);
    setAdditionalDetails({
      handleContinue: handleContinue,
    });
    setMode(STRINGS.MODAL_MODE.CONTINUE);
    setModalSize(STRINGS.MODAL_SIZE.X_SMALL);
    handleOpenModal();
  };

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);

  const handleSuccess = () => {
    handleCloseModal();
  };

  const handleFailure = () => {
    setShowFailureModal(false);
    setAdditionalDetails((prev) => {
      const { error: _error, handleFailure: _handleFailure, ...rest } = prev;
      return rest;
    });
  };

  const handleContinue = () => {
    handleCloseModal();
    return true;
  };

  return {
    mode,
    modalSize,
    openModal,
    showFailureModal,
    additionalDetails,
    handleCloseModal,
    handleFailure,
    openSuccessModal,
    openFailureModal,
    openWarningModal,
  };
}
